import request from '@/utils/request'
// 获取左侧菜单列表
export const findIndexRoot = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findIndexRoot',
        data: params
    })
}
// 根据模块id 查找 右侧目录结构
export const findIndexStructure = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findIndexStructure',
        data: params
    })
}

// 获取线图数据
export const findIndexData = params => {
    return request({
        method: 'POST',
        url: '/graphicallightweightdata/ms/findIndexData',
        data: params
    })
}
// 查询类型
export const queryByType = params => {
    return request({
        method: 'POST',
        url: '/graphicalCms/goods/queryByType',
        data: params,
        headers: {
            moduleId: 2
        }
    })
}
// 支付
export const pay = params => {
    return request({
        method: 'POST',
        url: '/payment/pay',
        data: params,
        headers: {
            moduleId: 2
        }
    })
}

// 查询订单详情
export const orderDetail = params => {
    return request({
        method: 'GET',
        url: `/payment/detail/${params}`,
        data: params,
        headers: {
            moduleId: 2
        }
    })
}

// 开具发票
export const openInvoice = params => {
    return request({
        method: 'POST',
        url: '/graphicalCms/invoice/add',
        data: params,
        headers: {
            moduleId: 2
        }
    })
}
// 发票详情
export const getInvoiceDetail = params => {
    return request({
        method: 'GET',
        url: '/graphicalCms/invoice/detail',
        params,
        headers: {
            moduleId: 2
        }
    })
}
// 订单列表
export const getOrderList = params => {
    return request({
        method: 'GET',
        url: '/payment/orderList',
        params,
        headers: {
            moduleId: 2
        }
    })
}